"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regularEventNameOfCohortedCustomEvent = exports.makeCohortableCustomEventName = exports.isCohortableCustomEventName = exports.Cohorts = void 0;
exports.toCohortedEventName = toCohortedEventName;
exports.fromCohortedEventName = fromCohortedEventName;
var Cohorts;
(function (Cohorts) {
    Cohorts["d1"] = "1";
    Cohorts["d3"] = "3";
    Cohorts["d5"] = "5";
    Cohorts["d7"] = "7";
    Cohorts["d15"] = "15";
    Cohorts["d30"] = "30";
    Cohorts["d60"] = "60";
    Cohorts["d90"] = "90";
    Cohorts["d90plus"] = "90+";
})(Cohorts || (exports.Cohorts = Cohorts = {}));
function toCohortedEventName(event, cohort) {
    return `${event}_cohort_${cohort}`;
}
function fromCohortedEventName(name) {
    const caseInsensitive_cohort_ = new RegExp("_cohort_", "i");
    return name.split(caseInsensitive_cohort_);
}
const isCohortableCustomEventName = (ev) => /_COHORT$/.test(ev !== null && ev !== void 0 ? ev : "");
exports.isCohortableCustomEventName = isCohortableCustomEventName;
const makeCohortableCustomEventName = (ev) => ev && (0, exports.isCohortableCustomEventName)(ev) ? ev : `${ev}_COHORT`;
exports.makeCohortableCustomEventName = makeCohortableCustomEventName;
const regularEventNameOfCohortedCustomEvent = (ev) => ev && (0, exports.isCohortableCustomEventName)(ev)
    ? ev.substring(0, ev.indexOf("_COHORT"))
    : ev;
exports.regularEventNameOfCohortedCustomEvent = regularEventNameOfCohortedCustomEvent;
